import React from "react";
import { Link } from "react-router-dom";
import { Button, Typography } from "@mui/material";

const NotFoundPage: React.FC = () => {
    return (
        <div style={{ textAlign: "center", paddingTop: "5%", paddingBottom: "5%" }}>
            <span style={{ fontSize: "15vw", fontWeight: "bold" }}>404</span>
            <Typography style={{ marginBottom: "2%", fontWeight: "bold" }} variant="h2">
                Errore: Pagina non trovata
            </Typography>
            <Typography style={{ marginBottom: "2%", paddingLeft: "15%", paddingRight: "15%" }} variant="h6">
                La pagina potrebbe non esistere. Se il problema persiste, contattare l'assistenza.
            </Typography>
            <Link to="/">
                <Button variant="contained" color="primary">
                    Ritorna alla Pagina Iniziale
                </Button>
            </Link>
        </div>
    );
};

export default NotFoundPage;
